import type { PortableTextListComponent } from '@portabletext/react';

const BulletList: PortableTextListComponent = ({ children }) => (
  <ul className="list-disc pl-8 md:pl-12">{children}</ul>
);

export default BulletList;

export const BulletListHtml: PortableTextListComponent = ({ children }) => (
  <ul>{children}</ul>
);
